import { Injectable } from "@angular/core";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { IRateSourceLookupService } from "../IRateSourceLookupService";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class RateSourceLookupService
  extends BaseLookupService<string, CubiqTS.RateSourceImpl>
  implements IRateSourceLookupService
{
  constructor() {
    super(CubiqTS.RateSourceImpl);
  }

  getRateSource(id: string): CubiqTS.RateSourceImpl {
    if (id == undefined || id == null) return null;
    var rateSource = this.getItem(id);
    return rateSource;
  }

  getItemKey(item: any): string {
    if (item.id != undefined && item.id != null) return item.id;
    return null;
  }
}
